const projectSetupTour = {
  id: 'project-setup',
  title: 'Project set up',
  summary: 'Create a project and get your team into it.',
  match: '/dashboard/yawn/project',
  autoStart: false,
  version: 1,
  steps: [
    {
      target: 'project-details',
      title: 'Start with the project',
      body: 'Give the project a name and details. Every schedule you create will sit underneath it.',
      placement: 'bottom',
      optional: true,
    },
    {
      target: 'project-revit-number',
      title: 'Link it to your Revit model',
      body: 'Paste your Revit project number here, and the project appears in the EarlyPlugin projects page.',
      tip: 'Find it in Revit under Manage → Settings → Project Information.',
      placement: 'bottom',
      optional: true,
    },
    {
      target: 'project-schedules-section',
      title: 'Your schedules',
      body: 'Every schedule for this project is listed here. Open one to start specifying.',
      placement: 'top',
      optional: true,
    },
    {
      target: 'project-add-schedule',
      title: 'Create a new schedule',
      body: 'Click "Add New", name the schedule, then pick a Master template — or switch the Masters filter to No to start from a previous project.',
      tip: 'Open "More settings" to choose which columns and data come across.',
      placement: 'left',
      optional: true,
    },
    {
      target: 'project-members',
      title: 'Bring in your team',
      body: 'Add people to the project and set what each of them can do.',
      tip: 'They need a company and a user account first — see Companies and Users in the main menu.',
      placement: 'top',
      optional: true,
    },
  ],
};

export default projectSetupTour;
